import { render, staticRenderFns } from "./yianManage.vue?vue&type=template&id=b4876610&scoped=true&"
import script from "./yianManage.vue?vue&type=script&lang=js&"
export * from "./yianManage.vue?vue&type=script&lang=js&"
import style0 from "./yianManage.vue?vue&type=style&index=0&id=b4876610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4876610",
  null
  
)

export default component.exports